import React from 'react';

import TowlieSvg from '../../assets/images/illust_liveview_coffee_list.svg';

const ErrorScreen = ({ translate, includeTowlie = true }) => {
  return (
    <div data-fd="app-bootstrap-error-screen">
      <div style={{ height: '80%', display: 'grid', textAlign: 'center' }}>
        <div style={{ maxWidth: '90%' }}>
          <h3>{translate('Something_went_wrong_please_refresh_the_page')}</h3>
        </div>
        {includeTowlie && (
          <div style={{ maxWidth: '90%' }}>
            <img src={TowlieSvg} alt={translate('Something_went_wrong')} />
          </div>
        )}
      </div>
    </div>
  );
};
export default ErrorScreen;
